// Docs: https://techdocs.akamai.com/ivm/reference/test-images-on-demand
import { atcBaseUrl } from '../src/constants/config';

type loaderProps = {
  src: string;
}

export default function akamaiLoader({ src }: loaderProps) {
  return `${atcBaseUrl}/psx-static/main/${src}`;
}
